import React from 'react'
import { connect } from 'react-redux'
import T from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import LoginForm from 'components/auth/Login/LoginForm'
import { login } from 'reducers/auth/reducer'
import withPromise from 'helpers/withPromise'
import LoginWithGoogle from 'routes/Auth/LoginWithGoogle/LoginWithGoogle'
import LoginWithMicrosoft from 'routes/Auth/LoginWithMicrosoft/LoginWithMicrosoft'
import Locale from 'components/common/Locale/Locale'
import OldBrowser from 'components/OldBrowser'
import { isIE } from 'constants/index'
import messages from './translate'

function Login({ login, loading, intl: { formatMessage } }) {
  const handleLogin = ({ email, password }) =>
    withPromise(login, {
      password,
      username: email,
    }).then(res => {
      if (res && res.error) return Promise.resolve(res)
    })

  return (
    <div className="login-form">
      {isIE ? (
        <OldBrowser />
      ) : (
        <>
          <div className="form-headline">
            <h2 className="login-form-title">
              {formatMessage(messages.login)}
            </h2>
            <Locale />
          </div>
          <LoginWithGoogle />
          <LoginWithMicrosoft />
          <div className="section-headline">
            <FormattedMessage {...messages.authSubtitle} />
          </div>
          <LoginForm onSubmit={handleLogin} loading={loading} />
        </>
      )}
    </div>
  )
}

Login.propTypes = {
  intl: T.shape({
    formatMessage: T.func,
  }).isRequired,
  login: T.func.isRequired,
  loading: T.bool.isRequired,
}

const enhance = connect(
  state => ({
    loading: state.getIn(['auth', 'loading']),
  }),
  { login },
)

export default enhance(injectIntl(Login))
